<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" @keyup.enter.native="submitForm" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文档名称" prop="docName">
              <a-input placeholder="请输入文档名称" v-model="model.docName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文档类型" prop="docType">
              <!-- <a-input placeholder="请输入文档类型" v-model="model.docType"></a-input> -->
              <!-- <j-dict-select-tag dictCode="device_importance" placeholder="请选择重要性" v-model="model.importance" /> -->
              <j-dict-select-tag dictCode="dev_docs_type" placeholder="请选择文档类型" v-model="model.docType" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文档说明" prop="docDesc">
              <a-input placeholder="请输入文档说明" v-model="model.docDesc"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="文档上传" prop="pictureObjId">
              <j-upload v-model="model.pictureObjId"></j-upload>

              <!-- <a-input placeholder="请输入文档对象ID(OSS服务对象ID)" v-model="model.pictureObjId"></a-input> -->
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="租户id" prop="tenantId">
              <a-input-number placeholder="请输入租户id" style="width: 100%" v-model="model.tenantId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="公司id" prop="orgId">
              <a-input placeholder="请输入公司id" v-model="model.orgId"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="删除状态" prop="delFlag">
              <a-input-number placeholder="请输入删除状态" style="width: 100%" v-model="model.delFlag" />
            </a-form-model-item>
          </a-col>-->
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'DevDocsForm',
    components: {
    },
    props: {
      // 表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      deviceData: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
        validatorRules: {
          docName: [{ required: true, message: '请输入文档名称!' }],
          pictureObjId: [{ required: true, message: '请选择文件' }],
        },
        url: {
          add: '/device/devDocs/add',
          edit: '/device/devDocs/edit',
          queryById: '/device/devDocs/queryById',
          getDeviceSelect: '/device/devList/selectDropList'
        },
        deviceList: []
      }
    },

    computed: {
      formDisabled () {
        return this.disabled
      }
    },
    created () {
      // 备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model))
      // getAction(this.url.getDeviceSelect).then(res => {
      //   this.deviceList = res.result.records
      // })
    },
    methods: {
      add (device) {
        // 
        const { id, devTypeId = '' } = device

        if (devTypeId) {
          this.modelDefault.devModelId = devTypeId
        } else {
          this.modelDefault.devId = id
        }


        this.edit(this.modelDefault)
      },
      edit (record) {
        this.model = Object.assign({}, record)
        this.visible = true
      },
      submitForm () {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl += this.url.add
              method = 'post'
            } else {
              httpurl += this.url.edit
              method = 'put'
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          }
        })
      }
    }
  }
</script>
